<template>
  <div>
    <v-img
      :src="require('../assets/landingbg_small.jpg')"
      height="500"
    >
      <v-row
        align="center"
        justify="center"
        class="landingpage-image-shader"
      >
        <v-col
          class="text-center landing-page-title-offset"
          cols="12"
        >
          <h1 class="display-3 font-weight-thin mb-2">
            Exposed
          </h1>
          <div class="blue--text font-weight-bold mb-4">BETA</div>
          <h4 class="subheading font-weight-regular">
            the creatives you love - all in one place
          </h4>
          <v-btn
            color="black"
            rounded
            dark
            class="mt-4"
            to="/persons"
          >Sign In Now</v-btn>
          <p class="caption mt-2">It's free</p>
        </v-col>
      </v-row>
    </v-img>

    <v-container class="landing">

      <v-row
        align="center"
        justify="center">
          <v-col
          >
            <h3>Like bookmarks, but with images</h3>
            <p>
              With Exposed, you can save creative people, agencies, and sites that inspire you.
              All their pictures will be imported so that you can easily scroll though the
              whole works of interesting artists, remember your favourite designers and get
              inspired by mindblowing agencies that you came across.
            </p>
          </v-col>
      </v-row>

      <v-row
        class="mt-4"
        align="center"
        justify="center">
          <v-col
            class="text-center"
          >
            <h6  class="display-1">How it works</h6>
          </v-col>
      </v-row>

      <v-row
        class="mt-2"
        align="center"
        justify="center"
        dark>
        <v-avatar
          color="black white--text"
          size="65"
        >1</v-avatar>
      </v-row>
      <v-row
        align="center"
        justify="center"
        dark>
        <v-col
          class="text-center"
          cols="6"
        >
          Add a designer, artist, agency or other creative with their websites to expose all their work.
        </v-col>
      </v-row>

      <v-row
        class="mt-2"
        align="center"
        justify="center"
        dark>
        <v-avatar
          color="black white--text"
          size="65"
        >2</v-avatar>
      </v-row>
      <v-row
        class="mt-2"
        align="center"
        justify="center"
        dark>
        <v-col
          class="text-center"
          cols="6"
        >
          Exposed will then find all the images on their websites and show them in a stream for each creative.
        </v-col>
      </v-row>

      <v-row
        align="center"
        justify="center"
        dark>
        <v-avatar
          color="black white--text"
          size="65"
        >3</v-avatar>
      </v-row>
      <v-row
        align="center"
        justify="center"
        dark>
        <v-col
          class="text-center"
          cols="6"
        >
          Whenever you need inspiration, want to see some cool images from your favourite creatives, or want to look up an image that you remember, you can come back to Exposed.
        </v-col>
      </v-row>

      <v-row
        class="mt-4"
        align="center"
        justify="center">
          <v-col
            class="text-center"
            cols="6"
          >
            <v-btn
              color="black"
              rounded
              dark
              class="mt-4"
              to="/persons"
            >Try it now!</v-btn>
            <p class="caption mt-2">It's free</p>
          </v-col>
      </v-row>

      <v-row
        class="mt-0"
        align="center"
        justify="center"
        dark>

        <v-col
          class="text-center"
          cols="9"
        >
          <div class="blue--text font-weight-regular">
            Hey there, this app is my little baby and it's still evolving.
            But although it's a Beta, I promise Exposed stores your creatives secure and save
            and if I ever have to turn this off you will get a list with all your creatives and the websites you saved.
            If you have any wishes, feedback, ideas drop me a line at init.giorgio@gmail.com.
            Thank you for being here &lt;3
          </div>
        </v-col>
      </v-row>

      <v-row
        class="mt-8"
        align="center"
        justify="center"
        dark>

        <v-btn
          color="grey"
          text
          to="/legal"
          >Legal Information
        </v-btn>

        <v-btn
          color="grey"
          text
          to="/privacy"
        >Data Privacy
        </v-btn>
      </v-row>




    </v-container>
  </div>
</template>

<script>
import '../style.css';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'LandingPage',
  components: {
  },
}
</script>
